import React from 'react';
import MuiAutoComplete, { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { CircularProgress } from '@mui/material';
import { AutocompleteProps } from 'types/autocomplete';

const Autocomplete: React.FC<AutocompleteProps> = ({
    options,
    value,
    loading,
    label,
    placeholder,
    error,
    helperText,
    matchKey,
    ...props
}) => {
    if (value && typeof value === 'string' && typeof options?.[0] === 'object') {
        value = options.find((op) => op?.[matchKey || 'value'] === value) || value || null;
    }

    return (
        <MuiAutoComplete
            value={value}
            options={options || []}
            aria-placeholder="Please select option"
            renderInput={(params: AutocompleteRenderInputParams) => (
                <TextField
                    {...params}
                    label={label || 'Members'}
                    variant="outlined"
                    placeholder={placeholder}
                    error={error}
                    helperText={helperText}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="warning" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
            {...props}
        />
    );
};

export default Autocomplete;
